import { createFetch } from '@vueuse/core';
import { destr } from 'destr';
import config from '../../config';

// Criação do fetch
export const apiInstance = createFetch({
    baseUrl: config.api.url,
    fetchOptions: {
        headers: {
            // Accept: 'application/json',
            // 'Content-Type': 'application/json',
            // 'Content-Type': 'multipart/form-data',
        },
    },
    options: {
        refetch: true, // Toda vez que tem uma mudança na query ele faz a request automaticamente
        async beforeFetch({ options }) {
            const token = useCookie('Authorization').value;
            if (token) {
                options.headers = {
                    ...options.headers,
                    Authorization: `Bearer ${token}`,
                };
            }
            return { options };
        },
        afterFetch(ctx) {
            const { data, response } = ctx;
            if (!response.ok) {
                const error = new Error(`HTTP Error: ${response.status}`);
                error.response = response;
                throw error;
            }
            let parsedData = null;
            try {
                parsedData = destr(data);
            } catch (error) {
                console.error('Deserialization Error:', error);
            }
            return { data: parsedData, response };
        },
        // onFetchError({ data, response, error }) {
        //     console.log('onFetchError---------inicio');
        //     // Logando o erro e lançando novamente
        //     if (response?.status === 401) {
        //         useCookie('Authorization').value = null; // Limpar o token
        //         window.location.replace('/dashboard/login'); // Redireciona para a tela de login
        //     } else if (response?.status === 403) {
        //         throw new ForbiddenError('Desculpe, você não tem permissão para executar esta ação.');
        //     }

        //     // Lançando o erro novamente para que o tratamento de erros no nível superior aconteça
        //     // throw error;
        //     return Promise.reject({ data, response, error });

        // }
    },
});

// Função de tratamento de erros centralizado
const handleError = async (error) => {
    const response = error.response.value;
    if (response) {
        const status = response.status;
        console.log('status error: ', status);
        if (status === 401) {
            useCookie('Authorization').value = null;
            window.location.replace('/dashboard/login'); // Redireciona para a tela de login
        } else if (response.status === 403) {
            throw new ForbiddenError('Desculpe, você não tem permissão para executar esta ação.');
        }

        let parsedBody = {};
        try {
            const text = await response.text(); // Lê o corpo da resposta
            console.log('rest api: ', text);
            parsedBody = destr(text); // Converte para objeto com segurança
        } catch (parseError) {
            console.warn('Erro ao ler corpo da resposta:', parseError);
        }

        console.log( {status,
            code: parsedBody?.code || 'unknown_error',
            message: parsedBody?.message || response.statusText || 'Erro desconhecido',
            errors: parsedBody?.errors || [],});

        // Repassar dados úteis para o catch do componente
        return Promise.reject({
            status,
            code: parsedBody?.code || 'unknown_error',
            message: parsedBody?.message || response.statusText || 'Erro desconhecido',
            errors: parsedBody?.errors || [],
        });

    }
    return Promise.reject(error);
};

// Wrapping todas as funções de requisição para lidar com erros
const request = async (url, method, body = null, headers = {}, options = {}) => {
    try {
        const requestBody = body instanceof FormData ? body : body ? JSON.stringify(body) : null;

        if (headers['Content-Type'] !== 'multipart/form-data') {
            headers = {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...options.headers,
                ...headers,
            };
        } else {
            headers = {};
        }

        const result = await apiInstance(url, {
            method,
            body: requestBody,
            ...options,
            headers
        });
        if (result.error?.value) {
            throw result;
        }

        return result.data; // Retorne apenas o campo data
    } catch (error) { // tem o campo error.valu e response.value
        // Chama o tratamento de erros
        await handleError(error);
        throw error; // Re-throw the error if needed
    }
};

// Métodos HTTP
const get = (url, headers = {}, options = {}) => request(url, 'GET', null, headers, options);
const post = (url, body, headers = {}, options = {}) => request(url, 'POST', body, headers, options);
const put = (url, body, headers = {}, options = {}) => request(url, 'PUT', body, headers, options);
const patch = (url, body, headers = {}, options = {}) => request(url, 'PATCH', body, headers, options);
const del = (url, headers = {}, options = {}) => request(url, 'DELETE', null, headers, options);

export { get, post, put, patch, del };
